"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CollapsibleCardContent = exports.CollapsibleCardAction = exports.CollapsibleCard = exports.COLLAPSIBLE_CARD_SEMANTIC = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _qa = require("../../utils/qa");
var _Button = require("../Button");
var _Icon = require("../Icon");
var _Truncate = require("../Truncate");
var _CollapsibleCardModule = _interopRequireDefault(require("./CollapsibleCard.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const COLLAPSIBLE_CARD_SEMANTIC = exports.COLLAPSIBLE_CARD_SEMANTIC = Object.freeze({
  neutral: 'neutral',
  success: 'success',
  information: 'information',
  warning: 'warning',
  danger: 'danger'
});
const CollapsibleCardAction = _ref => {
  let {
    children,
    className,
    testId
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _classify.default)(_CollapsibleCardModule.default.actionContainer, className),
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'wrapper'
    }),
    children: children
  });
};
exports.CollapsibleCardAction = CollapsibleCardAction;
const CollapsibleCardContent = _ref2 => {
  let {
    children,
    className,
    testId
  } = _ref2;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _classify.default)(_CollapsibleCardModule.default.contentContainer, className),
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'wrapper'
    }),
    children: children
  });
};
exports.CollapsibleCardContent = CollapsibleCardContent;
const CollapsibleCard = exports.CollapsibleCard = /*#__PURE__*/React.forwardRef((_ref3, ref) => {
  let {
    id,
    isOpen,
    paddingSize = 'small',
    onChange,
    classNames,
    title,
    children,
    semantic = 'neutral',
    headerIconName,
    headerIconType = 'solid',
    testId
  } = _ref3;
  const [collapsibleCardIsOpen, setCollapsibleCardIsOpen] = React.useState(Boolean(isOpen));
  React.useEffect(() => {
    setCollapsibleCardIsOpen(Boolean(isOpen));
  }, [isOpen]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'wrapper'
    }),
    className: (0, _classify.default)(_CollapsibleCardModule.default.wrapper, {
      [_CollapsibleCardModule.default.paddingMedium]: paddingSize === 'medium'
    }, classNames?.wrapper),
    ref: ref,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Button.UnstyledButton, {
      className: (0, _classify.default)(_CollapsibleCardModule.default.header, {
        [_CollapsibleCardModule.default.isOpen]: collapsibleCardIsOpen
      }, classNames?.title),
      onClick: e => {
        onChange?.(e, !collapsibleCardIsOpen, id);
        setCollapsibleCardIsOpen(!collapsibleCardIsOpen);
      },
      testId: (0, _qa.generateTestId)({
        base: testId,
        slot: 'header-button'
      }),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: _CollapsibleCardModule.default.headerContent,
        children: [!!headerIconName && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: (0, _classify.default)(_CollapsibleCardModule.default.iconContainer, _CollapsibleCardModule.default[semantic]),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
            name: headerIconName,
            type: headerIconType,
            size: "small",
            className: _CollapsibleCardModule.default[semantic],
            testId: (0, _qa.generateTestId)({
              base: testId,
              slot: 'header-icon'
            })
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Truncate.Truncate, {
          testId: (0, _qa.generateTestId)({
            base: testId,
            slot: 'title'
          }),
          children: title
        })]
      }), collapsibleCardIsOpen ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        name: "chevron-up",
        color: "secondary",
        size: "small",
        testId: (0, _qa.generateTestId)({
          base: testId,
          slot: 'chevron-up'
        })
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        name: "chevron-down",
        color: "secondary",
        size: "small",
        testId: (0, _qa.generateTestId)({
          base: testId,
          slot: 'chevron-down'
        })
      })]
    }), collapsibleCardIsOpen && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _classify.default)(_CollapsibleCardModule.default.content, classNames?.content),
      "data-testid": (0, _qa.generateTestId)({
        base: testId,
        slot: 'content'
      }),
      children: children
    })]
  });
});